import React, { useEffect, useRef, useCallback, useState } from 'react';
import './Valentine.css';
import mindBlownGif from '../image/mind-blown.gif';

function Valentine() {
  const [displayedText, setDisplayedText] = useState('');
  const showCursor = true;
  const [typingDone, setTypingDone] = useState(false);
  const [showGif, setShowGif] = useState(false);
  const [hearts, setHearts] = useState([]);
  const [noPos, setNoPos] = useState({ x: 0, y: 0 });
  const noRef = useRef(null);
  const fleeing = useRef(false);

  const fleeFromCursor = useCallback((e) => {
    if (!noRef.current || fleeing.current) return;
    const btn = noRef.current.getBoundingClientRect();
    // Check distance from cursor to nearest edge of the button
    const closestX = Math.max(btn.left, Math.min(e.clientX, btn.right));
    const closestY = Math.max(btn.top, Math.min(e.clientY, btn.bottom));
    const edgeDist = Math.sqrt((e.clientX - closestX) ** 2 + (e.clientY - closestY) ** 2);

    if (edgeDist < 5) {
      fleeing.current = true;
      const btnCenterX = btn.left + btn.width / 2;
      const btnCenterY = btn.top + btn.height / 2;
      const angle = Math.atan2(btnCenterY - e.clientY, btnCenterX - e.clientX);
      const jumpDist = 80 + Math.random() * 40;
      let newX = noPos.x + Math.cos(angle) * jumpDist;
      let newY = noPos.y + Math.sin(angle) * jumpDist;

      // Clamp to viewport
      const pad = 20;
      const naturalLeft = btn.left - noPos.x;
      const naturalTop = btn.top - noPos.y;
      const maxX = window.innerWidth - btn.width - pad;
      const maxY = window.innerHeight - btn.height - pad;
      newX = Math.max(pad - naturalLeft, Math.min(maxX - naturalLeft, newX));
      newY = Math.max(pad - naturalTop, Math.min(maxY - naturalTop, newY));

      setNoPos({ x: newX, y: newY });
      setTimeout(() => { fleeing.current = false; }, 200);
    }
  }, [noPos]);

  useEffect(() => {
    if (!typingDone || showGif) return;
    window.addEventListener('mousemove', fleeFromCursor);
    return () => window.removeEventListener('mousemove', fleeFromCursor);
  }, [typingDone, showGif, fleeFromCursor]);

  const question = "Rushi, will you be my valentine?";

  useEffect(() => {
    // Create falling hearts
    const h = [];
    for (let i = 0; i < 40; i++) {
      h.push({
        id: i,
        left: Math.random() * 100,
        animationDuration: Math.random() * 3 + 4,
        animationDelay: Math.random() * 8,
        opacity: Math.random() * 0.4 + 0.2,
        fontSize: Math.random() * 14 + 10,
      });
    }
    setHearts(h);
  }, []);

  useEffect(() => {
    let currentIndex = 0;
    const typeInterval = setInterval(() => {
      if (currentIndex <= question.length) {
        setDisplayedText(question.slice(0, currentIndex));
        currentIndex++;
      } else {
        setTypingDone(true);
        clearInterval(typeInterval);
      }
    }, 75);

    return () => clearInterval(typeInterval);
  }, [question]);

  const handleYes = () => {
    setShowGif(true);
  };

  return (
    <div className="valentine">
      {hearts.map((heart) => (
        <div
          key={heart.id}
          className="falling-heart"
          style={{
            left: `${heart.left}%`,
            animationDuration: `${heart.animationDuration}s`,
            animationDelay: `${heart.animationDelay}s`,
            opacity: heart.opacity,
            fontSize: `${heart.fontSize}px`,
          }}
        >
          &#x2764;
        </div>
      ))}

      <div className="valentine-content">
        <p className="valentine-text">
          {displayedText}
          {showCursor && <span className="valentine-cursor">|</span>}
        </p>

        {typingDone && !showGif && (
          <div className="valentine-buttons">
            <button className="valentine-btn yes-btn" onClick={handleYes}>
              Yes
            </button>
            <button
              ref={noRef}
              className="valentine-btn no-btn"
              style={{
                transform: `translate(${noPos.x}px, ${noPos.y}px)`,
                transition: 'transform 0.3s ease-out',
              }}
            >
              No
            </button>
          </div>
        )}

        {showGif && (
          <div className="gif-container">
            <img src={mindBlownGif} alt="Mind Blown" className="mind-blown-gif" />
          </div>
        )}
      </div>
    </div>
  );
}

export default Valentine;
